<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th>{{ $t("warehouse.仓库名称") }}</th>
            <th class="tx-center">{{ $t("warehouse.货架数") }}</th>
            <th class="tx-center">{{ $t("warehouse.库存种类") }}</th>
            <th class="tx-center">{{ $t("warehouse.库存总数量") }}</th>
            <th class="tx-center">{{ $t("warehouse.默认仓库") }}</th>
            <th class="tx-center">{{ $t("warehouse.状态") }}</th>
            <th class="wd-150">{{ $t("warehouse.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="valign-middle">
              <div>
                <p class="mg-b-5 tx-white">{{ item.name }}</p>
                <p class="mg-b-0 tx-white">
                  {{ item.province }} / {{ item.city }} / {{ item.area }} -
                  <a
                    href="javascript:;"
                    data-toggle="tooltip-primary"
                    data-placement="bottom"
                    :data-original-title="item.address"
                  >
                    <i class="tx-info fa fa-commenting" aria-hidden="true"></i>
                  </a>
                </p>
              </div>
            </td>
            <td class="tx-center valign-middle">
              <span class="tx-white">{{ item.shelfCnt }}</span>
            </td>
            <td class="tx-center valign-middle">
              <div>
                <router-link
                  class="tx-info"
                  :to="{ path: '/storage-details', query: { id: item.id } }"
                  target="_blank"
                  >{{ item.itemCnt }}</router-link
                >
              </div>
            </td>
            <td class="tx-center valign-middle">
              <span class="tx-white">{{ item.totalCnt }}</span>
            </td>
            <td class="tx-center valign-middle">
              <span class="tx-white">{{
                $t($dict.storeIsDefault[item.isDefault])
              }}</span>
            </td>
            <td class="tx-center valign-middle">
              <span :class="{ 'tx-white': item.status == 1 }">{{
                $t($dict.storeStatus[item.status])
              }}</span>
            </td>
            <td>
              <div v-if="isSysRights('Warehouse.updateWarehouse')">
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="editStore(item)"
                  >{{ $t("warehouse.修改仓库信息") }}</a
                >
              </div>
              <div>
                <router-link
                  class="tx-info"
                  :to="{ name: 'shelfMgrList', query: { id: item.id, ver: 2 } }"
                  target="_blank"
                  >{{ $t("warehouse.仓位管理") }}</router-link
                >
              </div>
              <div
                v-if="
                  item.isDefault == 2 &&
                  isSysRights('Warehouse.setDefaultWarehouse')
                "
              >
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="setDefaultStore(item)"
                  >{{ $t("warehouse.设为默认") }}</a
                >
              </div>
              <div v-if="isSysRights('Warehouse.changeWarehouseStatus')">
                <a
                  :class="item.status == 1 ? 'tx-danger' : 'tx-success'"
                  href="javascript:;"
                  @click="changeStatusStore(item)"
                >
                  {{
                    item.status == 1
                      ? $t("warehouse.停用")
                      : $t("warehouse.启用")
                  }}
                </a>
              </div>
              <div v-if="isSysRights('Warehouse.deleteWarehouse')">
                <a
                  class="tx-info"
                  href="javascript:;"
                  @click="delStore(item)"
                  >{{ $t("warehouse.删除") }}</a
                >
              </div>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="7">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i
                >{{ $t("warehouse.没有符合条件的仓库") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  methods: {
    editStore(item) {
      this.$emit("editStore", item);
    },
    changeStatusStore(item) {
      this.$emit("changeStatusStore", item);
    },
    setDefaultStore(item) {
      this.$emit("setDefaultStore", item);
    },
    delStore(item) {
      this.$emit("delStore", item);
    },
    gotoShelfMgr() {
      this.$router.push({ name: "shelfMgr" });
    },
  },
};
</script>
